import React from 'react'
import "../assets/styles/Footer-Link-Content.css";

const RefundPolicy = () => {
  return (
    <div className="footer-link-content">
      <h1>REFUND AND RETURN POLICY</h1>

      <section>
        <h2>Return Period</h2>
        <p>We accept returns within 24 hours of delivery. To be eligible for a return, your item must be unused and in the same condition that you received it.</p>
      </section>

      <section>
        <h2>Return Process</h2>
        <ul>
          <li>Contact our customer service team within 24 hours of receiving your order.</li>
          <li>Provide your order number and reason for return.</li>
          <li>Our team will guide you through the return process and provide a return shipping address.</li>
          <li>Package the item securely in its original packaging if possible.</li>
        </ul>
      </section>

      <section>
        <h2>Refund Process</h2>
        <p>Once we receive your returned item, we will inspect it and notify you of the status of your refund.</p>
        <ul>
          <li>If approved, your refund will be processed within 5-7 business days.</li>
          <li>The refund will be credited to the original payment method used for the purchase.</li>
          <li>Shipping costs are non-refundable unless the return is due to our error.</li>
        </ul>
      </section>

      <section>
        <h2>Non-Returnable Items</h2>
        <p>The following items cannot be returned:</p>
        <ul>
          <li>Customized or personalized jewelry items</li>
          <li>Items that have been worn, damaged, or altered</li>
          <li>Items marked as final sale or clearance</li>
        </ul>
      </section>

      <section>
        <h2>Damaged or Defective Items</h2>
        <p>If you receive a damaged or defective item:</p>
        <ul>
          <li>Contact us immediately with photos of the damage.</li>
          <li>We will arrange for a replacement or full refund including shipping costs.</li>
          <li>Return shipping for damaged items will be covered by us.</li>
        </ul>
      </section>

      <section>
        <h2>Cancellations</h2>
        <p>Orders can be cancelled before shipping. Once an order has been shipped, it will need to follow our return process.</p>
      </section>

      <section>
        <h2>Contact Us</h2>
        <p>If you have any questions about our return and refund policy, please contact us at <a href="mailto:example@gmail.com">example@gmail.com</a> or Mobile no: 9876543210.</p>
      </section>
    </div>
  );
};

export default RefundPolicy